import { createThumbnailFromBat } from '@/composables/useMaterialUpdater';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITextField } from '@/typescript/interfaces/ITextField';
import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IFont } from '@/typescript/interfaces/IFont';
import type { Ref } from 'vue';

async function generateThumbnail({
    selectedProduct,
    fonts,
    poleColor,
}: {
    selectedProduct: Ref<IProduct>;
    fonts: Ref<IFont[]>;
    poleColor: Ref<string>;
}): Promise<Blob> {
    const screenShotUtils = createThumbnailFromBat({ poleColor, fonts });
    const filteredFields = selectedProduct.value.configuration.fields.filter(
        (filteredField) =>
            filteredField.transform.position.x + filteredField.transform.position.y !== 0 ||
            (filteredField as IImageField)?.url !== undefined ||
            (filteredField as ITextField)?.text !== undefined,
    );
    const screenShot: Blob | Error = await screenShotUtils(filteredFields);
    if (screenShot instanceof Error) {
        throw screenShot;
    }

    return screenShot;
}

export { generateThumbnail };
